// extracted by mini-css-extract-plugin
module.exports = {"resultTitle":"biological-age_resultTitle__fXBRH","resultHeadline":"biological-age_resultHeadline__qlEE1"};